import React, { useContext } from "react";
import { useHistory } from "react-router-dom";
import { makeStyles } from "@material-ui/core/styles";

import Paper from "@material-ui/core/Paper";
import Box from "@material-ui/core/Box";
import Button from "@material-ui/core/Button";
import Divider from "@material-ui/core/Divider";
import Typography from "@material-ui/core/Typography";
import Grid from "@material-ui/core/Grid";

import CreditCardIcon from "@material-ui/icons/CreditCard";
import BusinessIcon from "@material-ui/icons/Business";
import EmailIcon from "@material-ui/icons/Email";
import EventIcon from "@material-ui/icons/Event";

import MainHeader from "../../components/MainHeader";
import Title from "../../components/Title";
import MainContainer from "../../components/MainContainer";

import { AuthContext } from "../../context/Auth/AuthContext";

const useStyles = makeStyles((theme) => ({
  mainPaper: {
    flex: 1,
    padding: theme.spacing(3),
    overflowY: "auto",
    ...theme.scrollbarStyles,
  },
  infoCard: {
    maxWidth: 480,
  },
  infoRow: {
    display: "flex",
    alignItems: "center",
    gap: theme.spacing(1.5),
    padding: theme.spacing(1.5, 0),
  },
  infoIcon: {
    color: theme.palette.text.secondary,
    flexShrink: 0,
  },
  infoLabel: {
    fontSize: "0.78rem",
    color: theme.palette.text.secondary,
    lineHeight: 1.2,
  },
  infoValue: {
    fontWeight: 500,
    fontSize: "0.95rem",
    color: theme.palette.text.primary,
  },
  trialWarning: {
    backgroundColor: theme.palette.type === "dark" ? "rgba(255,160,0,0.1)" : "#fff8e1",
    color: theme.palette.type === "dark" ? "#ffd54f" : "#7a5e00",
    border: `1px solid ${theme.palette.type === "dark" ? "rgba(255,160,0,0.25)" : "#ffe082"}`,
    borderRadius: theme.shape.borderRadius,
    padding: theme.spacing(1.5),
    marginBottom: theme.spacing(2),
    fontSize: "0.875rem",
  },
}));

const getDaysRemaining = (expirationDate) => {
  if (!expirationDate) return null;
  const now = new Date();
  const exp = new Date(expirationDate);
  const diff = Math.ceil((exp.getTime() - now.getTime()) / (1000 * 60 * 60 * 24));
  return diff;
};

const Subscription = () => {
  const classes = useStyles();
  const { user } = useContext(AuthContext);

  const history = useHistory();

  const daysRemaining = getDaysRemaining(user?.company?.trialExpiration);
  const isExpired = daysRemaining !== null && daysRemaining <= 0;
  const isTrialSoon = daysRemaining !== null && daysRemaining > 0 && daysRemaining <= 7;

  return (
    <MainContainer>
      <MainHeader>
        <Title>Assinatura</Title>
      </MainHeader>

      <Paper className={classes.mainPaper} variant="outlined">
        <Box className={classes.infoCard}>
          {/* Trial warning */}
          {daysRemaining !== null && (
            <Box className={classes.trialWarning}>
              <Typography variant="body2" style={{ fontWeight: 500 }}>
                {isExpired
                  ? "Seu período de teste expirou. Assine para continuar usando o sistema."
                  : isTrialSoon
                  ? `Seu período de teste termina em ${daysRemaining} dia${daysRemaining === 1 ? "" : "s"}. Assine em breve!`
                  : `Você está no período de teste — ${daysRemaining} dia${daysRemaining === 1 ? "" : "s"} restantes.`}
              </Typography>
            </Box>
          )}

          {/* Info rows */}
          <Box className={classes.infoRow}>
            <BusinessIcon className={classes.infoIcon} />
            <div>
              <Typography className={classes.infoLabel}>Empresa</Typography>
              <Typography className={classes.infoValue}>
                {user?.company?.name || "—"}
              </Typography>
            </div>
          </Box>
          <Divider />

          <Box className={classes.infoRow}>
            <EmailIcon className={classes.infoIcon} />
            <div>
              <Typography className={classes.infoLabel}>E-mail de cobrança</Typography>
              <Typography className={classes.infoValue}>
                {user?.company?.email || "—"}
              </Typography>
            </div>
          </Box>
          <Divider />

          {user?.company?.trialExpiration && (
            <>
              <Box className={classes.infoRow}>
                <EventIcon className={classes.infoIcon} />
                <div>
                  <Typography className={classes.infoLabel}>Expiração do trial</Typography>
                  <Typography className={classes.infoValue}>
                    {new Date(user.company.trialExpiration).toLocaleDateString("pt-BR")}
                  </Typography>
                </div>
              </Box>
              <Divider />
            </>
          )}

          <Box style={{ marginTop: 24 }}>
            <Button
              variant="contained"
              color="primary"
              fullWidth
              startIcon={<CreditCardIcon />}
              // O pagamento é sempre de uma fatura: leva para a lista de
              // faturas (abrir o modal sem fatura aqui quebrava a tela).
              onClick={() => history.push("/financeiro?tab=faturas")}
            >
              Ver faturas e pagar
            </Button>
          </Box>
        </Box>
      </Paper>
    </MainContainer>
  );
};

export default Subscription;
